export interface IGlobalSlice {
    error: {
        code?: number;
        message?: string;
    };
    menuOpen: boolean;
    rightMenuOpen: boolean;
}

export interface IRootSlice {
    globalSlice: IGlobalSlice;
}
export interface INameSpaceDTO {
    id: number;
    title: string;
    title_for_url: string;
    is_published: boolean;
    is_deleted: boolean;
    modified_date: string;
}

export interface IFile {
    copyright: string;
    description: string;
    file_type: 'video' | 'file' | 'image';
    filename: string;
    id: number;
    is_deleted: boolean;
    preview_filename: string;
}

export interface IDocumentDTO {
    namespace_id: number;
    document_id: number;
    files?: IFile[];
    parent_document_id: number | null;
    root_parent_document_id: number | null;
    children: string[];
    level: number;
    title: string;
    title_for_url: string;
    is_published: boolean;
    is_deleted: boolean;
    version: number;
    is_active: boolean;
    modified_by_user: number;
    modified_date: string;
    position: number;
    id?: number;
}

export interface IDocumentWithBodyDTO extends IDocumentDTO {
    body: string;
}

export interface ISearchDocument {
    title: string;
    title_for_url: string;
    document_id: number;
    namespace_id: number;
    rank: number;
}

export interface ISearchResponse {
    documents: ISearchDocument[];
    total: number;
}

export interface IMostPopularDocument {
    url: string;
    title_for_url: string;
    document_id: number;
    title: string;
}

export interface IAdvAccountInfo {
    adv_name: string;
    details: string;
    disclaimer: string;
    erid: string;
    inn: string;
    url: string;
}

export interface IDocumentSlice {
    tree: Record<string, Record<string, IDocumentDTO>>;
    name: string;
    documentBody: string;
    namespace: string;
    namespaceMap: Record<number, string>;
}

export const initialState: IDocumentSlice = {
    tree: {},
    name: null,
    documentBody: '',
    namespace: 'key',
    namespaceMap: {},
};

